import { BaseRepository } from '../../../infra/base.repository'
import { ConfigService } from '../../../infra/config'
import type { FormTemplate } from './form-template'

export class FormTemplatesRepository extends BaseRepository<FormTemplate> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.toolsApiUrl + '/' + 'form-templates', token, cache)
    }

    async copy(formTemplateId: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.toolsApiUrl +
                '/form-templates/' +
                formTemplateId +
                '/copy?token=' +
                this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async addModels() {
        const { json, statusCode, message } = await this.request.get(
            this.config.toolsApiUrl + '/form-templates/add-models?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
